import { render, staticRenderFns } from "./searchChetouIndex.vue?vue&type=template&id=a1edd454&scoped=true&"
import script from "./searchChetouIndex.vue?vue&type=script&lang=js&"
export * from "./searchChetouIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1edd454",
  null
  
)

export default component.exports